import { AppDispatch } from '../../redux/store';
import { NodeProps } from '@xyflow/react';
import { useDispatch } from 'react-redux';
import { AccessTime, Add, ChatBubbleOutline, Email, ForkLeftOutlined } from '@mui/icons-material';
import { addingConditionAutomationFlag, addingEmailAutomationFlag, addingSMSAutomationFlag, addingTimerAutomationFlag } from '../../redux/slices/automation';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { brand, gray } from '../../theme/themePrimitives';
import React, { useState } from 'react';
import { settingSelectedEdge, settingSelectedNode } from '../../redux/slices/workflow';

const actions: {
    id: 'phone' | 'email' | 'condition' | 'timer';
    label: string;
    icon: JSX.Element;
}[] = [
    { id: 'phone', label: 'SMS', icon: <ChatBubbleOutline /> },
    { id: 'email', label: 'Email', icon: <Email /> },
    { id: 'condition', label: 'Condition', icon: <ForkLeftOutlined /> },
    { id: 'timer', label: 'Time Delay', icon: <AccessTime /> }
];

const ActionNode: React.FC<NodeProps> = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [showButtons, setShowButtons] = useState(false);

    const addActionHandler = (value: 'phone' | 'email' | 'condition' | 'timer') => {
        dispatch(settingSelectedNode(null));
        dispatch(settingSelectedEdge(null));
        if (value === 'phone') {
            dispatch(addingSMSAutomationFlag(true));
        } else if (value === 'email') {
            dispatch(addingEmailAutomationFlag(true));
        } else if (value === 'timer') {
            dispatch(addingTimerAutomationFlag(true));
        } else if (value === 'condition') {
            dispatch(addingConditionAutomationFlag(true));
        }
    };

    return (
        <Box minWidth="400px" maxWidth="400px">
            <Box display="flex" justifyContent="center">
                <Button
                    variant="outlined"
                    startIcon={<Add />}
                    onClick={() => setShowButtons(!showButtons)}
                    sx={{ backgroundColor: 'white' }}
                >
                    ADD ACTION
                </Button>
            </Box>{showButtons && <Box
                mt={2}
                p={2}
                borderRadius="100px"
                width="100%"
                bgcolor="white"
            // sx={{
            //     display: 'flex',
            //     justifyContent: 'space-between',
            //     alignItems: 'center',
            //     backgroundColor: '#fff',
            //     borderRadius: '50px',
            //     boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
            //     padding: '10px',
            //     minWidth: '400px',
            //     maxWidth: '90%',
            //     margin: 'auto',
            //     gap: 2
            // }}
            >
                <Box display="flex" borderRadius="100px" alignItems="center" border={`1px solid ${gray[200]}`}>
                    {actions.map(({ id, label, icon }) => (
                        <Box
                            key={id}
                            sx={{
                                'flex': 1,
                                'textAlign': 'center',
                                'padding': '15px',
                                'cursor': 'pointer',
                                'transition': '0.3s',
                                'borderRight': id === 'timer' ? 'none' : `1px solid ${gray[200]}`,
                                '&:hover': {
                                    backgroundColor: brand[300],
                                    color: 'white',
                                    borderTopRightRadius: id === 'timer' ? '80px' : '0',
                                    borderBottomRightRadius: id === 'timer' ? '80px' : '0',
                                    borderTopLeftRadius: id === 'phone' ? '80px' : '0',
                                    borderBottomLeftRadius: id === 'phone' ? '80px' : '0'
                                }
                            }}
                            onClick={() => {
                                addActionHandler(id);
                                setShowButtons(false);
                            }}
                        >
                            <IconButton color={
                                id === 'timer' ? 'error' : id === 'phone' ? 'primary' : id === 'email' ? 'success' : 'warning'
                            }>{icon}</IconButton>
                            <Typography variant="body2" marginTop={1} whiteSpace="nowrap">
                                {label}
                            </Typography>
                        </Box>
                    ))}</Box>
            </Box>}
        </Box>
    );
};

export default ActionNode;
